export default {
	title: 'Mon profil',
	messages: {
		choose_plan: 'Choisir un plan',
		unlock_immediately:
			'Débloquer immédiatement toutes les fonctionnalités',
		current_subscription: 'Votre abonnement actuel'
	},
	language: {
		title: 'Langue',
		description: "Choisissez la langue de l'interface",
		languages: {
			de: 'Allemand',
			en: 'Anglais',
			es: 'Espagnol',
			fr: 'Français',
			hi: 'Hindi',
			it: 'Italien',
			ja: 'Japonais',
			pt: 'Portugais',
			zh: 'Chinois (mandarin)'
		}
	},
	theme: {
		title: 'Sélection du thème'
	},
	actions: {
		manage_subscription: 'Gérer mon abonnement'
	},
	api_access: {
	  title: "Accès API (serveur MCP)",
	  description: "Permet aux agents IA (Claude, ChatGPT, etc.) d'accéder à vos projets Gerositus via le Model Context Protocol. Le token donne le même accès que le vôtre — gardez-le secret.",
	  endpoint: "URL de l'endpoint MCP",
	  no_token: "Aucun token — générez-en un pour activer l'accès agent IA.",
	  default_token_name: "Token par défaut",
	  status_active: "Actif",
	  status_revoked: "Révoqué",
	  created_at: "Créé le {{date}}",
	  last_used_at: "Dernière utilisation le {{date}}",
	  never_used: "Jamais utilisé",
	  generate: "Générer un token",
	  regenerate: "Renouveler le token",
	  revoke: "Révoquer le token",
	  copy: "Copier",
	  copied: "Copié dans le presse-papier",
	  copy_failed: "Échec de la copie",
	  config_example: "Exemple de configuration client MCP",
	  reveal_title: "Sauvegardez votre token maintenant",
	  reveal_done: "Je l'ai sauvegardé",
	  reveal_warning_title: "C'est la seule fois où ce token sera affiché",
	  reveal_warning_body: "Copiez-le dans un endroit sûr (gestionnaire de mots de passe). Si vous le perdez, vous devrez le renouveler. Toute personne possédant ce token peut lire vos projets Gerositus.",
	  regenerate_confirm_title: "Renouveler le token d'accès ?",
	  regenerate_confirm_body: "Le token actuel sera révoqué immédiatement et un nouveau sera émis. Tout agent IA utilisant l'ancien token devra être reconfiguré.",
	  revoke_confirm_title: "Révoquer le token d'accès ?",
	  revoke_confirm_body: "Tout agent IA utilisant ce token perdra l'accès. Vous pourrez en générer un nouveau à tout moment."
	}
};
